import { FunctionalComponent, h } from 'preact';
import { Router } from 'preact-router';
import "./style.css";
import Home from '../routes/home';
import MiddlePage from "../routes/middle";
import Detail from "../routes/details";
import Signin from '../routes/signin';
import VisitthecommunityPage from '../routes/visitthecommunity';
import ExtensionPage from "../routes/extension"
import LoginPage from "../routes/login";
import PhonePage from "../routes/phone";
import Personal from "../routes/personal";
import FeedBack from "../routes/feedback";
import Pointsdetails from "../routes/pointsdetails";
import Information from "../routes/information";
import MemberZone from "../routes/memberZone";
import Integraldetail from "../routes/integraldetail";
import ExchangeRecord from "../routes/exchangeRecord";
import BrowsePage from "../routes/browse";
import SetUp from "../routes/setup";
import SearchWrap from '../routes/home/component/SearchWrap';
import NotFoundPage from '../routes/notfound';
import Store from "../store";
import 'lib-flexible';
import 'antd-mobile/es/global'
import iframeBridge from "./../iframeBridge";
import { useEffect } from 'preact/hooks';
import Navigation from "./Navigation";
import store from '../store';
import { getAcId, storeAccessToken, storeAcId } from '../store/UserStore';
import { isWeiXinAndQQ } from '../utils/utils';
import UM from '../utils/UM';
const initLogin=async ()=>{
    const search = new URLSearchParams(window.location.search);
    window.clarity("set", "ghid",search.get('gh_id')||"default");
    // window.clarity("set", "unionId",code);
    const acId=await getAcId();
    window.clarity("set", "acId",acId||search.get('acId')||"default");
    window.clarity("set", "scence",search.get('scence')||"default");
    // if(window.location.href.indexOf("blogger")==-1&&!isWeiXinAndQQ()&&!search.has("acId")&&search.get("scence")!='landing'&&!acId&&window.location.href.indexOf("loginpage")==-1){
    //   const DivData: any=document.createElement("div");
    //   DivData.style.width="100vw";
    //   DivData.style.height="100vh";
    //   DivData.style.position="fixed";
    //   DivData.style.display="none";
    //   DivData.id="auto_div";
    //   DivData.style.top=0;
    //   DivData.style.left=0;
    //   // DivData.style.backgroundColor="red";
    //   DivData.style.zIndex=10000;
    //   document.getElementsByTagName("body")[0].appendChild(DivData);
    //   DivData.onclick=(e: any)=>{
    //       e.stopPropagation();
    //       let lastUrl=`${window.location.protocol}//${window.location.host}/loginpage?${search.toString()}`;
    //       if(search.has("itemId")&&window.location.href.indexOf("/detail")!=-1){
    //         lastUrl=`${lastUrl}&previouspages=detail`
    //       }
    //       window.location.replace(lastUrl);
    //   }
    // }
}
initLogin();
iframeBridge((code: any)=>{
    console.log(code)
});
const App: FunctionalComponent = () => {
    const initLogin=()=>{
        const search = new URLSearchParams(window.location.search);
        if(search.has("recordItemId")&&search.has("recordPlatform")&&search.get("scence")=="landing"&&!search.has("acId")){
            if(search.has("recordImgUrl")&&search.get("recordPlatform")=="pdd"){
              Store.pddStatus=2;
              Store.recordImgUrl=search.get("recordImgUrl");
            }
            if(search.has("recordImgUrl")&&search.get("recordPlatform")=="jd"&&search.has("recordUrl")){
              Store.pddStatus=2;
              Store.recordImgUrl=search.get("recordImgUrl");
              Store.recordUrl=search.get("recordUrl");
            }
            if(search.has("recordToken")){
              Store.postHomeBToken({
                token:search.get("recordToken"),
              })
              search.delete("recordToken");
            }
            Store.postHomeGoodsRecord({
              platform:search.get("recordPlatform"),
              itemId:search.get("recordItemId")
            })
            Store.recordPlatform=search.get("recordPlatform");
            search.delete("recordItemId");
            search.delete("recordPlatform");
            search.delete("recordImgUrl");
            search.delete("recordUrl");
            window.history.replaceState(null, "", `?` + search);
        }
        //群接龙跳转
        if(!search.has("acId")&&search.has("u")&&search.has("h")&&search.get("scence")=="landing"){
          store.JumpPro({
            u:search.get("u"),
            gh_id:search.get("gh_id"),
            h:search.get("h"),
            e:search.get("e"),
            invite:search.get("invite")
          });
          search.delete("u");
          search.delete("h");
          search.delete("e");
          search.delete("invite");
          window.history.replaceState(null, "", `?` + search);
        }
        if (search.has("acId")) {
            const acId=search.get('acId');
            storeAcId(search.get('acId'));
            storeAccessToken(search.get('token'))
            search.delete("token");
            search.delete("acId");
            search.delete("code");
            UM({ page: "微博授权",value:acId});
            window.history.replaceState(null, "", `?` + search);
          }
    }
    useEffect(()=>{
        //获取登陆信息
        initLogin();
        //获取微博配置信息
        Store.WeiBoCollectionQueryCjsList();
        let startTime=new Date().getTime();
        document.addEventListener('visibilitychange',() => {
            if(document.visibilityState === 'hidden') {

            }else {
              if(Store.pddStatus==2&&new Date().getTime()-startTime>3000){
                Store.pddStatus=1
              }
              Store.GetWeixinMywebchatCheckUserSign();
            }
          });
    },[])
    return (
        <div id="preact_root">
            <div id="container" />
            <SearchWrap  store={Store} />
            <Router>
                <Home path="/" store={Store} />
                <MiddlePage path="/middle" store={Store} />
                <Detail path="/detail" store={Store} />
                <Signin path="/signin" store={Store} />
                <VisitthecommunityPage  path="/visitthecommunity" store={Store} />
                <ExtensionPage  path="/extension" store={Store} />
                <PhonePage path="/phone" store={Store} />
                <LoginPage path="/loginpage" store={Store} />
                <Personal path="/personal" store={Store} />
                <FeedBack path="/feedback" store={Store} />
                <Pointsdetails path="/pointsdetails" store={Store}/>
                <Information path="/information" store={Store} />
                <MemberZone path="/memberzone" store={Store} />
                <Integraldetail path="integraldetail" store={Store} />
                <BrowsePage  path="/browse" store={Store} />
                <SetUp path="/setup" store={Store} />
                <ExchangeRecord path="exchangeRecord" store={Store} />
                <NotFoundPage default />
            </Router>
            <Navigation 
                store={Store}
            />
        </div>
    );
};

export default App;
